"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnClUsd = exports.EsClClp = exports.EsClUsd = void 0;
class EsClUsd {
    constructor() {
        this.locale = "es-cl";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d 'de' MMMM 'de' yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EsClUsd = EsClUsd;
class EsClClp {
    constructor() {
        this.locale = "es-cl";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, d 'de' MMMM 'del' yyyy",
        };
        this.currencyFormat = {
            code: "CLP",
            symbol: "CLP$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EsClClp = EsClClp;
class EnClUsd {
    constructor() {
        this.locale = "en-cl";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnClUsd = EnClUsd;
